// extracted by mini-css-extract-plugin
export default {"wrap":"ts-z","logoContainer":"us-z","brandImg":"vs-z","logoImg":"ws-z","logoButton":"xs-z"};